const headerElement = document.querySelector('.header');
const announcementBarHeight = document.querySelector('.announcement-bar').offsetHeight;

const changeHeaderHeight = debounce(() => {
  headerElement.style.top = `${announcementBarHeight}px`
}, 300);

['load', 'resize'].forEach(event =>
  window.addEventListener(event, changeHeaderHeight)
);

(() => {
  if (customElements.get('announcement-bar')) {
    return;
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.selectors = {
        slider: '[data-slider]',
        slide: '.swiper-slide',
      };
      this.elements = {
        slider: this.querySelector(this.selectors.slider)
      }
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.elements.slider)
        return;

      const loop = this.elements.slider.querySelectorAll(this.selectors.slide).length > 1

      this.options = {
        slider: {
          loop: loop,
          slidesPerView: 1,
          direction: 'vertical',
          autoplay: {
            delay: 3000
          }
        },
      };

      this.slider = new Swiper(
        this.elements.slider,
        this.options.slider,
      );
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
})();
